module.exports = __webpack_public_path__ + "img/tag.92b32a66.svg";